export const newId = () => globalThis.crypto.randomUUID();
//# sourceMappingURL=ids.js.map